import Vue from 'vue'
import { Mixin } from 'vue-mixin-decorator'

// @ts-ignore
import lodash from 'lodash'

@Mixin
export default class LodashMixin extends Vue {
    copyObject(obj) {
        return JSON.parse(JSON.stringify(obj))
    }

    groupByLodash(collection: Array<any>, iteratee: Function) {
        return lodash.groupBy(collection, iteratee)
    }

    isString(value: any) {
        return lodash.isString(value)
    }

    uniqArray(arr: Array<any>, attribute: string) {
        return lodash.uniqBy(arr, attribute)
    }

    stringContainsJSON(value: any) {
        if (value)
            try {
                JSON.parse(value)
            } catch (e) {
                return false
            }
        return true
    }

    arrayDifference(oldVal: Array<any>, newVal: Array<any>) {
        return lodash.difference(oldVal, newVal)
    }

    isObjectEmpty(obj) {
        return lodash.isEmpty(obj)
    }

    getDifference(oldVal: any, newVal: any) {
        return lodash.reduce(
            oldVal,
            function (result, value, key: any) {
                return lodash.isEqual(value, newVal[key]) ? result : result.concat(key)
            },
            []
        )
    }

    hasConstraints(constraints: any, type: string) {
        let result = false
        if (constraints) {
            Object.values(constraints).forEach((constraint: any) => {
                if (constraint[type]) {
                    result = true
                }
            })
        }

        return result
    }
}
